var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { staticClass: "mt-4 mb-2", attrs: { "justify-center": "" } },
    [
      _c("v-card", { staticClass: "terms text-xs-center pb-4" }, [
        _c("i", { staticClass: "icon-ic-check" }),
        _c(
          "div",
          [
            _c("h2", [_vm._v("Rechazada")]),
            _c("p", { staticClass: "mt-4" }, [
              _vm._v("Tu solicitud ha sido rechazada")
            ]),
            _c("div", { staticClass: "pb-4" }, [
              _c("h3", { staticClass: "mt-3" }, [
                _vm._v(
                  "Notifica a tu superior sobre el rechazo de la solicitud"
                )
              ])
            ]),
            _c("span", { staticClass: "pt-3 d-block" }),
            _c(
              "v-btn",
              {
                staticClass: "primary-button",
                on: { click: _vm.returnDashboard }
              },
              [_vm._v("Continuar")]
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-11ec9fd0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11ec9fd0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/stepper/reject-affiliation.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-11ec9fd0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/stepper/reject-affiliation.vue
// module chunks = 0 1 2 3